import {
  IconAlertTriangle,
  IconCheck,
  IconHourglass,
  IconX,
} from "@tabler/icons-react"
import { CertificateStatus } from "@tfg/db"
import { useTranslation } from "react-i18next"

import {
  CertificateStatusEnum,
  CertificateStatusType,
} from "@tfg/types/schemas/enum"

import { Badge } from "~/components/Badge.tsx"

type Props = {
  status: CertificateStatusType | null
}

export function CertificateStatusBadge({ status }: Props) {
  const certificateStatusDetails = useGetCertificateStatus(status)
  if (!certificateStatusDetails) return null
  return (
    <Badge
      text={certificateStatusDetails.translation}
      color={certificateStatusDetails.color}
      icon={certificateStatusDetails.icon}
      isShort={false}
    />
  )
}

function useGetCertificateStatus(status: CertificateStatusType | null) {
  const { t } = useTranslation("certificates")
  const result = CertificateStatusEnum.safeParse(status)
  let certificateStatus: CertificateStatusType
  if (!result.success) {
    return null
  } else {
    certificateStatus = result.data
  }
  switch (certificateStatus) {
    case CertificateStatus.PENDING:
      return {
        color: "var(--mantine-color-orange-6)",
        icon: <IconAlertTriangle size={16} />,
        translation: t(`certificateStatus.PENDING`),
      }
    case CertificateStatus.PROCESSED:
      return {
        color: "var(--mantine-color-green-6)",
        icon: <IconCheck size={16} />,
        translation: t(`certificateStatus.PROCESSED`),
      }
    case CertificateStatus.REJECTED:
      return {
        color: "var(--mantine-color-red-6)",
        icon: <IconX size={16} />,
        translation: t(`certificateStatus.REJECTED`),
      }
    case CertificateStatus.NOT_UPLOADED:
      return {
        color: "var(--mantine-color-gray-6)",
        icon: <IconHourglass size={16} />,
        translation: t(`certificateStatus.NOT_UPLOADED`),
      }
    default:
      return null
  }
}
